import $ from "jquery";
import { CT_VALIDATION_MESSAGE, REPORT_TITLE } from "../../../constants/Constants";
import { covidReportState } from "./initialData";

export function generateCovidReport(reportTitle) {
	
	console.log("Generating report");

  if(reportTitle == REPORT_TITLE.HRCT_CHEST_ILD){
    var grid1 = document.getElementById("Table1");

    var $findingsChecked = $("#HRCT_finding");
    if (!$findingsChecked[0].checked) {
      console.log($findingsChecked[0]);
      $("#SingleFinding").remove();
    } else {
      $("#SingleFinding :checkbox").first().remove();
    }
    console.log($findingsChecked);

    var $PriorXrayChecked = $("#Xray");
    var $PriorCTChecked = $("#CT");

    if (!$PriorXrayChecked[0].checked && !$PriorCTChecked[0].checked) {
      $("#prior").remove();
      $("#none").css("display", "block");
    } else {
      if (!$PriorXrayChecked[0].checked) {
        console.log($PriorXrayChecked[0]);
        $("#Xray").remove();
        $("#x").remove();
      } else {
        $("#Xray").remove();
      }

      if (!$PriorCTChecked[0].checked) {
        console.log($PriorCTChecked[0]);
        $("#CT").remove();
        $("#C").remove();
      } else {
        $("#CT").remove();
      }
      $("#none").remove();
    }
    var $cardiacNormalChecked = $("#normaldiv");
    var $cardiacEnlrgChecked = $("#enlarged");

    if (!$cardiacNormalChecked[0].checked && !$cardiacEnlrgChecked[0].checked) {
      $("#cardiac").remove();
    } else {
      if (!$cardiacNormalChecked[0].checked) {
        console.log($cardiacNormalChecked[0]);
        $("#normaldiv").remove();
        $("#norm").remove();
      } else {
        $("#normaldiv").remove();
      }

      if (!$cardiacEnlrgChecked[0].checked) {
        console.log($cardiacEnlrgChecked[0]);
        $("#enlarged").remove();
        $("#enlar").remove();
      } else {
        $("#enlarged").remove();
      }
    }

    var $coronaryArterypresent = $("#present");
    var $coronaryArteryAbsent = $("#absent");
    if (
      !$coronaryArterypresent[0].checked &&
      !$coronaryArteryAbsent[0].checked
    ) {
      $("#Coronary").remove();
    } else {
      if (!$coronaryArterypresent[0].checked) {
        console.log($coronaryArterypresent[0]);
        $("#present").remove();
        $("#pre").remove();
      } else {
        $("#present").remove();
      }

      if (!$coronaryArteryAbsent[0].checked) {
        console.log($coronaryArteryAbsent[0]);
        $("#absent").remove();
        $("#abs").remove();
      } else {
        $("#absent").remove();
      }
    }

    /*	var flag =0;
			for (var i = 0, row; row = grid1.rows[i]; i++) {
				if( row.cells[0].children[0].checked){
					flag = 1;
				}
			}	
		
		//var $tableChecked = $("#HRCT_finding_Table");
		if(flag === 0){
			console.log("Table not selected");
			//$tableChecked[0].remove();
			 $("#findingSentence1").remove();
			grid1.parentNode.removeChild(grid1);
		}else{*/
    var sentences = [];
    for (var i = 0, row; (row = grid1.rows[i]); i++) {
      //iterate through rows
      //rows would be accessed using the "row" variable assigned in the for loop
      console.log($(row).attr("id"));
      var sentence = String(covidReportState.sentences_map[$(row).attr("id")]); //_ilenear
      var locations = [];
      var zones = [];
      var distributions = [];
      //console.log(sentence);
      for (var j = 1, col; (col = row.cells[j]); j++) {
        if (col.children[0].checked) {
          if (j <= 2) {
            locations.push($(col).text());
          } else if (j <= 5) {
            zones.push($(col).text());
          } else {
            distributions.push($(col).text());
          }
        }
      }
      if (
        locations.length === 0 &&
        zones.length === 0 &&
        distributions.length === 0
      ) {
        sentence = sentence.replace(sentence, "");
      } else {
        if (locations.length === 0) {
          sentence = sentence.replace(" in the $locations lung", "");
        }
        if (zones.length === 0) {
          sentence = sentence.replace(" in the $zones zone", "");
        }
        if (distributions.length === 0) {
          sentence = sentence.replace(" and $distributions distribution", "");
        }

        if (locations.length !== 0 || zones.length !== 0) {
          var final_Sentence = sentence
            .replace("$locations", locations.join(" " + "and" + " "))
            .replace("$zones", zones.join(" " + "and" + " "))
            .replace("$distributions", distributions.join(" " + "and" + " "));
          console.log(final_Sentence);
          final_Sentence =
            final_Sentence.charAt(0).toUpperCase() +
            final_Sentence.slice(1).toLowerCase();
          sentences.push(final_Sentence);
        } else {
          var final_Sentence = sentence
            .replace("$locations", locations.join(" " + "and" + " "))
            .replace("$zones", zones.join(" " + "and" + " "))
            .replace(" " + "and" + " ", "with")
            .replace("$distributions", distributions.join(" " + "and" + " "));
          final_Sentence =
            final_Sentence.charAt(0).toUpperCase() +
            final_Sentence.slice(1).toLowerCase();
          sentences.push(final_Sentence);
        }
      }
    }
    $.each(sentences, function (i, val) {
        $(".findingSentence").append(val);
        $(".findingSentence").append("<br>");
    });
    // $tableChecked[0].remove();
    grid1.parentNode.removeChild(grid1);

    //}

    // Findings for table 2
    var grid2 = document.getElementById("Table2");
    var grid2flag = 0;
    for (var i = 0, row; (row = grid2.rows[i]); i++) {
      if (row.cells[0].children[0].checked) {
        grid2flag = 1;
      }
    }

    //var $tableChecked = $("#HRCT_finding_Table");

    var sentencesofTable2 = [];
    for (var i = 0, row; (row = grid2.rows[i]); i++) {
      //iterate through rows
      //rows would be accessed using the "row" variable assigned in the for loop
      var sentence = String(covidReportState.sentences_map[$(row).attr("id")]);
      console.log($(row.cells[0]).text());
      console.log(sentence);
      var solitary = [];
      var multiple = [];
      var size = [];
      //console.log(sentence);
      for (var j = 1, col; (col = row.cells[j]); j++) {
        if (col.children[0].checked) {
          if (j == 1) {
            solitary.push($(col).text());
          } else if (j == 2) {
            multiple.push($(col).text());
          }
        }
      }
      size.push($(row.cells[3].children[0]).val());
      console.log(size);
      if (solitary.length === 0 && multiple.length === 0) {
        sentence = sentence.replace(sentence, "");
      } else {
        if (solitary.length === 0) {
          sentence = sentence.replace("$Solitary enlarged", "");
        }
        if (multiple.length === 0) {
          sentence = sentence.replace("$Multiple enlarged", "");
        }
        if (size.length === 0 || size[0] === "") {
          console.log(sentence);
          sentence = sentence.replace(" measuring $size mm", "");
          console.log(sentence);
        }
        var final_Sentence = sentence
          .replace("$Solitary", solitary.join(" " + "and" + " "))
          .replace("$Multiple", multiple.join(" " + "and" + " "))
          .replace("$size", size.join(" " + "and" + " "));
        console.log(final_Sentence);
        if (multiple.length !== 0) {
          final_Sentence = final_Sentence.replace(
            "node measuring",
            "nodes, largest measuring"
          );
        }
        final_Sentence =
          final_Sentence.charAt(0).toUpperCase() +
          final_Sentence.slice(1).toLowerCase();
        final_Sentence = replaceTags(final_Sentence);
        sentencesofTable2.push(final_Sentence);
        console.log(final_Sentence);
      }
      console.log(sentencesofTable2);
    }
    if (sentencesofTable2.length === 0) {
      console.log("Table not selected");
      $("#lymphPresent").remove();
      $("#lymphNode").remove();
      $("#findingSentence2").remove();
      $("#spaceafterLymph").remove();
    } else {
      $("#noLymph").remove();
    }
    $.each(sentencesofTable2, function (k, val) {
        $(".findingSentenceOfTable2").append(val);
        $(".findingSentenceOfTable2").append("<br>");
    });

    grid2.parentNode.removeChild(grid2);
    //Convert pop up in html
    //covidChest = $("#hrctPopupContext").html();
    // console.log($("#hrctPopupContext").html());
    return $("#hrctPopupContext").html();
    
  }

	
  if (reportTitle == REPORT_TITLE.HRCT_CHEST_COVID) {
	console.log("Going Inside IF");
    var noneChecked = document.getElementById("RADIO_1542043688976_1");
    var priorChecked = document.getElementById("RADIO_1542043688976_0");
    if (noneChecked.checked || priorChecked.checked) {
      $("#EmptyNoneDiv").remove();
    }

    var comparison = document.getElementsByClassName("comparison");
    for (let i = 0; i < comparison.length; ) {
      if (!comparison[i].children[0].checked) {
        comparison[i].remove();
        continue;
      }
      i++;
    }

    var comparisonChecked = document.getElementsByClassName("comparison");
    for (let i = 0; i < comparisonChecked.length; i++) {
      if (comparisonChecked[i].children[0].checked) {
        comparisonChecked[i].children[0].remove();
      }
    }

    var finding1 = document.getElementsByClassName("covid-19Find1");
    console.log("Finding is ");
    console.log(finding1);
    finding1[0].style.color='unset';
    
    if (!finding1[0].children[0].checked) {
        console.log("--------------IF ----------------");
      finding1[0].remove();
      var Impression1 = document.getElementsByClassName("covid-19Imp1");
      Impression1[0].style.color='unset';
      Impression1[0].remove();
      $("#EmptyDivFind1").remove();
    } else {
        console.log("------------ELSE --------------");
      $("#EmptyDivFind1").remove();
      $("#ConstantFindingTitle").remove();
      $("#ConstantFindingSpace").remove();
      $("#ConstantFindingContent").remove();
    //   $("#RADIO_1542229828887_0").remove();
      var Impression1 = document.getElementsByClassName("covid-19Imp1");
      if(Impression1[0].style.color != 'unset'){
        Impression1[0].style.color='unset';
      }
      
      finding1[0].children[0].remove();
      var finding1Text = $("#textFind1").val();
      finding1Text = replaceTags(finding1Text);
      console.log("INside else ");
      
      document.getElementById("ParaFind1").innerHTML = finding1Text;
      document.getElementById("ParaFind1").style.color='unset';
      console.log(document.getElementById("ParaFind1"));
      $("#textFind1").remove();
      var Impression1Text = $("#textPara1").val();
      Impression1Text = replaceTags(Impression1Text);
      document.getElementById("ParaImpr1").innerHTML = Impression1Text;
      document.getElementById("ParaImpr1").style.color='unset';
      $("#textPara1").remove();

      finding1[0]?.classList?.remove("covid-19Find1");
      Impression1[0]?.classList?.remove("covid-19Imp1");
    document.getElementById("ParaFind1").removeAttribute('id');
    document.getElementById("ParaImpr1").removeAttribute('id');
    }
    

    var finding2 = document.getElementsByClassName("covid-19Find2");
    finding2[0].style.color='unset';
    if (!finding2[0].children[0].checked) {
      finding2[0].remove();
      var Impression2 = document.getElementsByClassName("covid-19Imp2");
      Impression2[0].style.color='unset';
      Impression2[0].remove();
      $("#EmptyDivFind2").remove();
    } else {
      $("#EmptyDivFind2").remove();
      $("#ConstantFindingTitle").remove();
      $("#ConstantFindingSpace").remove();
      $("#ConstantFindingContent").remove();
      var Impression2 = document.getElementsByClassName("covid-19Imp2");
      Impression2[0].style.color='unset';
      finding2[0].children[0].remove();
      var finding2Text = $("#textFind2").val();
      finding2Text = replaceTags(finding2Text);
      document.getElementById("ParaFind2").innerHTML = finding2Text;
      document.getElementById("ParaFind2").style.color='unset';
      $("#textFind2").remove();
      var Impression2Text = $("#textPara2").val();
      Impression2Text = replaceTags(Impression2Text);
      document.getElementById("ParaImpr2").innerHTML = Impression2Text;
      document.getElementById("ParaImpr2").style.color='unset';
      $("#textPara2").remove();

      finding2[0]?.classList?.remove("covid-19Find2");
      Impression2[0]?.classList?.remove("covid-19Imp2");
      document.getElementById("ParaFind2").removeAttribute('id');
      document.getElementById("ParaImpr2").removeAttribute('id');
    }

    var finding3 = document.getElementsByClassName("covid-19Find3");
    finding3[0].style.color='unset';
    if (!finding3[0].children[0].checked) {
      finding3[0].remove();
      var Impression3 = document.getElementsByClassName("covid-19Imp3");
      Impression3[0].style.color='unset';
      Impression3[0].remove();
      $("#EmptyDivFind3").remove();
    } else {
      $("#EmptyDivFind3").remove();
      $("#ConstantFindingTitle").remove();
      $("#ConstantFindingSpace").remove();
      $("#ConstantFindingContent").remove();
      var Impression3 = document.getElementsByClassName("covid-19Imp3");
      Impression3[0].style.color='unset';
      finding3[0].children[0].remove();
      var finding3Text = $("#textFind3").val();
      finding3Text = replaceTags(finding3Text);
      document.getElementById("ParaFind3").innerHTML = finding3Text;
      document.getElementById("ParaFind3").style.color='unset';
      $("#textFind3").remove();
      var Impression3Text = $("#textPara3").val();
      Impression3Text = replaceTags(Impression3Text);
      document.getElementById("ParaImpr3").innerHTML = Impression3Text;
      document.getElementById("ParaImpr3").style.color='unset';
      $("#textPara3").remove();

      finding3[0]?.classList?.remove("covid-19Find3");
      Impression3[0]?.classList?.remove("covid-19Imp3");
      document.getElementById("ParaFind3").removeAttribute('id');
      document.getElementById("ParaImpr3").removeAttribute('id');
    }

    var finding4 = document.getElementsByClassName("covid-19Find4");
    finding4[0].style.color='unset';
    if (!finding4[0].children[0].checked) {
      finding4[0].remove();
      var Impression4 = document.getElementsByClassName("covid-19Imp4");
      Impression4[0].style.color='unset';
      Impression4[0].remove();
      $("#EmptyDivFind4").remove();
    } else {
      $("#EmptyDivFind4").remove();
      $("#ConstantFindingTitle").remove();
      $("#ConstantFindingSpace").remove();
      $("#ConstantFindingContent").remove();
      var Impression4 = document.getElementsByClassName("covid-19Imp4");
      Impression4[0].style.color='unset';
      finding4[0].children[0].remove();
      var finding4Text = $("#textFind4").val();
      finding4Text = replaceTags(finding4Text);
      document.getElementById("ParaFind4").innerHTML = finding4Text;
      document.getElementById("ParaFind4").style.color='unset';
      $("#textFind4").remove();
      var Impression4Text = $("#textPara4").val();
      Impression4Text = replaceTags(Impression4Text);
      document.getElementById("ParaImpr4").innerHTML = Impression4Text;
      document.getElementById("ParaImpr4").style.color='unset';
      $("#textPara4").remove();

      finding4[0]?.classList?.remove("covid-19Find4");
      Impression4[0]?.classList?.remove("covid-19Imp4");
      document.getElementById("ParaFind4").removeAttribute('id');
      document.getElementById("ParaImpr4").removeAttribute('id');
    }

    var $cardiac1NormalChecked = $("#RADIO_1542043688986_0");
    var $cardiac1EnlrgChecked = $("#RADIO_1542043688986_1");

    if (
      !$cardiac1NormalChecked[0].checked &&
      !$cardiac1EnlrgChecked[0].checked
    ) {
      $("#cardiac1").remove();
    } else {
      if (!$cardiac1NormalChecked[0].checked) {
        console.log($cardiac1NormalChecked[0]);
        $("#RADIO_1542043688986_0").remove();
        $("#NORMAL_ID").remove();
      } else {
        $("#RADIO_1542043688986_0").remove();
      }

      if (!$cardiac1EnlrgChecked[0].checked) {
        console.log($cardiac1EnlrgChecked[0]);
        $("#RADIO_1542043688986_1").remove();
        $("#ENLARGED_ID").remove();
      } else {
        $("#RADIO_1542043688986_1").remove();
      }
    }

    var $coronary1Arterypresent = $("#RADIO_1542043688987_0");
    var $coronary1ArteryAbsent = $("#RADIO_1542043688987_1");
    if (
      !$coronary1Arterypresent[0].checked &&
      !$coronary1ArteryAbsent[0].checked
    ) {
      $("#Coronary1").remove();
    } else {
      if (!$coronary1Arterypresent[0].checked) {
        console.log($coronary1Arterypresent[0]);
        $("#RADIO_1542043688987_0").remove();
        $("#PRESENT_ID").remove();
      } else {
        $("#RADIO_1542043688987_0").remove();
      }

      if (!$coronary1ArteryAbsent[0].checked) {
        console.log($coronary1ArteryAbsent[0]);
        $("#RADIO_1542043688987_1").remove();
        $("#ABSENT_ID").remove();
      } else {
        $("#RADIO_1542043688987_1").remove();
      }
    }
    console.log("Response is");
    return $("#covidPopupContext").html();
  }
}


function replaceTags(element) {
    return element.replace(
      /(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/gi,
      ""
    );
  }

